import BaseModel from '../../base';

export default class Option extends BaseModel {
  constructor(option = {}, url) {
    super(option, url);

    this.name = option.name;
    this.image = option.image;
    this.score = option.score;
    this.is_correct = option.is_correct || false;
  }
}
